import React from 'react';
import './Appointment.scss';
import { useTranslation } from 'react-i18next';
import { MdEmail, MdPhone, MdLocationOn, MdDirections } from 'react-icons/md';

const Appointment = () => {
    const { t } = useTranslation();

    return (
        <section className='appointment-section pb-70' data-aos="fade-up">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <div className="location-card">
                            <div className="location-icon">
                                <MdLocationOn size={48} />
                            </div>
                            <div className="location-content">
                                <h3>Unsere Praxis</h3>
                                <p className="address">{t('appointment.address')}</p>
                                <a 
                                    href="https://www.google.com/maps/search/?api=1&query=Kornstraße+53a,+47918+Tönisvorst"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="directions-link"
                                >
                                    <MdDirections size={20} />
                                    <span>Route planen</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-6">
                        <div className="appointment-form-area">
                            <div className="appointment-header">
                                <p className="appointment-subtitle">{t('appointment.subTitle')}</p>
                                <h2 className="appointment-title">{t('appointment.title')}</h2>
                                <p className="appointment-description">{t('appointment.description')}</p>
                            </div>

                            <div className="contact-info-wrapper">
                                <div className="contact-info-item">
                                    <div className="contact-icon">
                                        <MdPhone size={24} />
                                    </div>
                                    <div className="contact-text">
                                        <h4>{t('footer.phoneNumber')}</h4>
                                        <p><a href={`tel:${t('footer.phone')}`}>{t('footer.phone')}</a></p>
                                    </div>
                                </div>
                                <div className="contact-info-item">
                                    <div className="contact-icon">
                                        <MdEmail size={24} />
                                    </div>
                                    <div className="contact-text">
                                        <h4>E-Mail</h4>
                                        <p><a href="mailto:anmeldung@zahnarzt-st-toenis.de">anmeldung@zahnarzt-st-toenis.de</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appointment;